import moment from 'moment';

export const formatDOB = (raw?: string | null): string | null => {
  if (!raw) return null;
  const m = moment(raw, ['YYYY-MM-DD', 'DD/MM/YYYY'], true);
  if (!m.isValid()) return null;
  const age = moment().diff(m, 'years');
  return `${m.format('DD/MM/YYYY')} (${age} años)`;
};
